module.exports = __webpack_public_path__ + "static/media/logo.e24527ba.svg";